export default __webpack_public_path__ + "3fd48743e82bd46625b8b834e5b5b470.svg";